export const startPageOptions: Array<string> = [
  'I’m working on my first CRE deal',
  'I have completed transactions as a General Partner/Lead Investor',
  'I represent a real estate fund or syndication company',
  'Other',
];
